import { render } from "./noteBox.vue?vue&type=template&id=7ed5d9c3"
import script from "./noteBox.vue?vue&type=script&lang=js"
export * from "./noteBox.vue?vue&type=script&lang=js"

import "./noteBox.vue?vue&type=style&index=0&id=7ed5d9c3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__